// Constantes de productos
export const PRODUCT_ROUTE = '/products';
export const PRODUCT_ROUTE_HOME = '/products/productosParaHome';
export const PRODUCT_ROUTE_SINGLE_ITEM = '/products/single';
export const AGREGAR_PRODUCTO_EN_MASA = '/products/bulkCreation';
export const OBTENER_PRODUCTOS_POR_ID = '/products/getByIds';
export const ENVIAR_IMAGEN = '/products/images';
export const PUBLICAR_PRODUCTOS_EN_MASA = '/products/publicacionEnMasa';
export const CAMBIAR_PRECIO_EN_MASA = '/products/ModificarPrecioEnMasa';
export const MARCAS = '/products/marcas';
export const RUBROS = '/products/getRubros';

// Constantes de panel
export const ENVIAR_IMAGENES = '/panel/images';
export const ENVIAR_PRODUCTOS_HOME = '/panel/productos';

// Constantes de ventas
export const VENTA_ROUTE = '/ventas';
export const VENTA_POR_FECHA = '/ventas/ventas-desde-hasta';
export const LOCALES = '/pedidos/getShopsList';

// Constantes de Reportes
export const DATOS_REPORTE = '/reportes';
export const REPORTE_PROVEEDORES = '/reportes/proveedores';
export const REPORTE_PRODUCTOS = '/reportes/productos';

// Constantes de cuentas corrientes 
export const VENTA_CUENTA_CORRIENTE = "/cuentas-corrientes";
export const EXCEL_CUENTA_CORRIENTE = "/cuentas-corrientes/all";
export const CREAR_MOVIMIENTO_CUENTA_CORRIENTE = "/movimientos/crearMovimiento";

// Constantes de ventana Pedidos
export const VENTAS_PARA_PEDIDO = '/pedidos';
export const VALIDATE_FOR_SALE = '/pedidos/validateProducts';
export const VENTAS_POR_ID = '/pedidos/byId';
export const BORRAR_PEDIDO = '/pedidos';
export const AGREGAR_PEDIDO = '/pedidos';

export const PEDIDO_ESTADO = {
  PENDIENTE: 'PENDIENTE',
  CONFIRMADO: 'CONFIRMADO',
  PRODUCCION: 'PRODUCCION',
  LISTO: 'LISTO',
  ENTREGADO: 'ENTREGADO'
}

export const MEDIO_DE_PAGO = {
  CUENTA_CORRIENTE: 'CuentaCorriente',
  EFECTIVO: 'Efectivo',
  CREDITO_Y_EFECTIVO: 'Credito + Efectivo',
  NINGUNO: 'Ninguno',
  TC: 'Tarjeta Crédito',
  TD: 'Tarjeta Débito',
  TRANSFERENCIA: 'Transferencia',
  EFECTIVO_Y_TC: 'Efectivo y T. crédito',
  EFECTIVO_Y_TD: 'Efectivo y T. débito',
  EFECTIVO_Y_TRANSFERENCIA: 'Efectivo + Transferencia',
  CUENTA_CORRIENTE_Y_TC: 'Saldo y T. crédito',
  CUENTA_CORRIENTE_Y_TD: 'Saldo y T. débito',
  CUENTA_CORRIENTE_Y_TRANSFERENCIA: 'Saldo y transferencia',
}

// constantes del Logger
export const LOGGING_URL = '/clientlogs';

// Constantes del Toast
export const SNACKBAR_SEVERITY = {
  success: 'success',
  info: 'info',
  warning: 'warning',
  error: 'error',
};